module.exports = __webpack_public_path__ + "img/矩形(3).0bbd18e6.png";